import { render, staticRenderFns } from "./CreateTintStyle.vue?vue&type=template&id=3444ac7c&"
import script from "./CreateTintStyle.vue?vue&type=script&lang=js&"
export * from "./CreateTintStyle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports